import { CSSProperties } from 'react';

export const ROTATION_ANGLE = '-10deg';

export const ANIMATION_DURATIONS = {
  entrance: 30,
  maskReveal: 20,
  bar: { start: 40, end: 70 },
  barScaleY: { start: 45, end: 75 },
};

export const CAMERA_CONFIG = {
  scale: { start: 1.15, end: 1 },
  rotateX: { start: 2, end: 0 },
  rotateY: { start: -2, end: 0 },
  delay: 0,
  duration: 120,
  perspectivePx: 2000,
};

export const PARALLAX_DEPTHS = {
  back: { start: 0, end: -30 },
  mid: { start: 0, end: -15 },
  front: { start: 0, end: 0 },
};

export const FONT_SIZES = {
  doubleDigit: 150,
  singleDigit: 300,
};

export const ENTRANCE_ANIMATION = {
  translateY: { fromTop: [-200, 0], fromBottom: [200, 0] },
  rotateX: { fromTop: [-45, 0], fromBottom: [45, 0] },
  opacity: [0, 0.5, 1],
  opacitySteps: [0, 0.25, 1],
};

export const FLOAT_ANIMATION = {
  amplitude: 8,
  rotateXAmplitude: 2,
};

export const SHEEN_ANIMATION = {
  cycleDuration: 5,
  positionSteps: [0, 0.25, 1],
  positionValues: [-100, 150, 150],
};

export const ELEMENT_DELAYS = {
  months: 10,
  ofTraining: 20,
  throughout: 50,
  theYear: 60,
  topics: 70,
};

export const CHAR_REVEAL_ANIMATION = {
  text: 'throughout',
  charStaggerFrames: 1.5,
  charStartOffset: 15,
  springConfig: { damping: 12, stiffness: 180, mass: 0.6 },
};

export const LAYOUT_POSITIONS = {
  backgroundEllipse: { top: 200, left: 320, width: 500, height: 500 },
  monthsCard: { top: -70, left: 380, width: 245, height: 500, paddingTop: 180 },
  trainingText: { top: 400, left: 465, fontSize: 150, lineHeight: 150 },
  topicsCard: { top: 600, left: 1310, width: 245, height: 400 },
  diagonalLine: { top: 480, left: 1250 },
} as const;

export const getFontSize = (count: number): number =>
  count >= 10 ? FONT_SIZES.doubleDigit : FONT_SIZES.singleDigit;

export const CURVED_LINES_PATH =
  'M-244.346 922.769 C-46.974 624.508 228.513 740.319 405.375 882.55 C516.986 972.305 750.398 1126.38 1051.32 1036.27 C1366.21 941.982 1405.2 539.185 1814.35 592.521 C2223.49 645.858 2391.14 440.743 2307.27 351.539 C2223.39 262.335 1937.57 484.335 1558.05 490.114 C1178.54 495.893 957.617 -62.3497 239.434 357.675 C125.456 431.162 -137.975 550.693 -354.633 427.215 C-626.937 272.023 -757.869 208.658 -1185.43 338.602';

export const EXIT_TRANSITION = {
  duration: 45,
  statBoxDuration: 30,
  fadeOutDuration: 35,
  bgFadeStartOffset: 30,
};

export const CURVED_LINES_DEFAULT_STYLE: CSSProperties = {
  stroke: '#D5D5D5',
  strokeWidth: 60,
  opacity: 0.1,
  fill: 'none',
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

export const CURVED_LINES_ANIMATION = {
  duration: 120,
};
